export default "__VITE_ASSET__NsVIkbdQ__"